import { TeamInfoResponse } from "interfaces";
import instance from "lib/axiosInterceptor";

export async function getTeamInfoService(): Promise<TeamInfoResponse> {
  const response = await instance.get<TeamInfoResponse>("/MyTeam");
  return response.data;
}
